package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

data class ModalNotesState(
    val show: Boolean = false,
    val questionId: String = "",
    val notes: String = ""
)
